import axiosInstance from './AxiosInstance';

const StoreService = {
  fetchStore: async (page, pageSize, sortBy, order, searchTerm) => {
    const queryObj = { 
      page, 
      pageSize,
      sortBy,
      order
    };
    
    if (searchTerm && searchTerm.trim()) {
      queryObj.store_number = searchTerm;
    }

    try {
      const response = await axiosInstance.get('/store', {
        params: queryObj,
      });
      return response.data;
    } catch (error) {
      console.error("Failed to fetch stores:", error);
      throw error;
    }
  },

  createStore: async (data) => {
    try {
      const response = await axiosInstance.post('/store', data);
      return response.data;
    } catch (error) {
      console.error('Error creating Store:', error);
      throw error;
    }
  },
  
  updateStore: async (id, data) => {
    try {
      const response = await axiosInstance.put(`/store/${id}`, data);
      return response.data;
    } catch (error) {
      console.error(`Error updating Store with ID ${id}:`, error);
      throw error;
    }
  },
  
  deleteStore: async (id) => {
    try {
      const response = await axiosInstance.delete(`/store/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting Store with ID ${id}:`, error);
      throw error;
    }
  }
};

export default StoreService;

const fetchStores = async (page=1, pageSize=100, storeNumber) => {
  const queryObj = { page, pageSize };
  console.log("queryobj... stores",queryObj);
  if (storeNumber) {
      queryObj.store_number = storeNumber;
  }
  console.log("Query Object:", queryObj);

  try {
      const response = await axiosInstance.get('/store', {
          params: queryObj,
      });
      console.log("Response:", response.data);
      return response.data;
  } catch (error) {
      console.error("Failed to fetch vendors:", error);
      throw error;
  }
};

  
export {fetchStores};